module.exports = __webpack_public_path__ + "static/heroes-bg-map-websize-07c4f7527d3cc93496488f2a27863fcc.gif";